<template>
  <div>
    <loader v-if="loading"/>
    <line-chart
      v-else
      :key="chartKey"
      :chartdata="dataCollection"
      :options="chartOptions"
    />
    <b-row>
      <b-col>
        <div>Zobrazovat po</div>
        <b-form-select v-model="selectedTimeUnit" :options="timeUnitsOptions"/>
      </b-col>
      <b-col v-if="containsDeviation">
        <div>Seskupit podle</div>
        <b-form-select v-model="selectedTimeGroupingUnit" :options="timeUnitGroupingOptions"/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart';
import Loader from '@/components/utils/Loader';
import DatasetLoadMixin from '@/components/logging/DatasetLoadMixin';
import moment from 'moment';

export default {
  name: 'LogChart',
  mixins: [
    DatasetLoadMixin,
  ],
  props: {
    varsIds: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedTimeUnit: 'day',
      selectedTimeGroupingUnit: 'D',
      containsDeviation: false, // specifies some dataset deviation to display group option control?
      timeUnitsOptions: [
        { value: 'year', text: this.$t('year') },
        { value: 'quarter', text: this.$t('quarter') },
        { value: 'month', text: this.$t('month') },
        { value: 'week', text: this.$t('week') },
        { value: 'day', text: this.$t('day') },
        { value: 'hour', text: this.$t('hour') },
        { value: 'minute', text: this.$t('minute') },
        { value: 'second', text: this.$t('second') },
      ],
      timeUnitGroupingOptions: [
        { value: 'YS', text: this.$t('year') },
        { value: 'QS', text: this.$t('quarter') },
        { value: 'MS', text: this.$t('month') },
        { value: 'W', text: this.$t('week') },
        { value: 'D', text: this.$t('day') },
        { value: 'H', text: this.$t('hour') },
        { value: 'T', text: this.$t('minute') },
        { value: 'S', text: this.$t('second') },
      ],
      colors: [
        '#ff6384',
        '#36a2eb',
        '#cc65fe',
        '#ffce56',
      ],
    };
  },
  computed: {
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            type: 'time',
            distribution: 'linear',
            time: {
              unit: this.selectedTimeUnit,
              displayFormats: {
                day: 'L',
                hour: 'H',
              },
              tooltipFormat: 'LLL',
            },
          }],
        },
      };
    },
    chartKey() {
      return `${this.selectedTimeUnit}-${this.dataRefreshCounter}`;
    },
  },
  methods: {
    processData(data) {
      this.containsDeviation = data.datasets.reduce((result, dataset) => result || dataset.uses_deviation, false);
      return {
        datasets: data.datasets.map(
          (dataset, index) => {
            let label = `${dataset.place} ${dataset.service} ${dataset.label} (${dataset.unit})`;
            if (dataset.summary_value_text !== '') {
              label = `${label} [${dataset.summary_value_text}]`;
            }
            const resultedDataset = {
              label,
              data: dataset.data.map(item => ({ x: moment.utc(item.x), y: item.y })),
              borderColor: this.colors[index],
              fill: {
                disabled: true,
              },
              steppedLine: dataset.is_boolean,
            };
            if (dataset.type) {
              resultedDataset.type = dataset.type;
            }
            if (dataset.uses_deviation) {
              resultedDataset.type = 'bar';
            }
            if (resultedDataset.type === 'bar') {
              resultedDataset.backgroundColor = this.colors[index];
            }
            if (resultedDataset.type === 'line') {
              resultedDataset.lineTension = 0;
            }

            return resultedDataset;
          },
        ),
      };
    },
  },
  components: {
    Loader,
    LineChart,
  },
};
</script>

<style scoped>

</style>
